var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsMerchandising(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 39.253,
    viewBox: "0 0 46 39.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "skills_merchandising",
    d: "M129.672,66.655l-5.082,4.453a1.267,1.267,0,0,1-1.839-.193l-2.807-3.92-.678,24.249a1.24,1.24,0,0,1-1.258,1.21H96.179a1.272,1.272,0,0,1-1.258-1.21l-.678-24.249-2.807,3.872a1.263,1.263,0,0,1-1.839.193l-5.034-4.4a1.22,1.22,0,0,1-.145-1.694l7.212-8.954A7.434,7.434,0,0,1,97.486,53.2h3.388a1.085,1.085,0,0,1,.92.581c1.162,2.323,2.71,3.872,5.566,3.872s4.4-1.549,5.566-3.872a1.084,1.084,0,0,1,.92-.581h3a7.6,7.6,0,0,1,5.9,2.807l7.212,8.954a1.354,1.354,0,0,1-.29,1.694Z",
    transform: "translate(-84.139 -53.199)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsMerchandising);
export default __webpack_public_path__ + "static/media/skills_merchandising.c3344f18799021904864c14521ea0828.svg";
export { ForwardRef as ReactComponent };